import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import Menu from "./Menu";
import Booking from "./Booking";
import Slider from "./Slider";
import Dataentry from "./Dataentry";
import SiteFooter from "./SiteFooter";
import axios from 'axios';
import Live from './Live';
import Popup from './Popup';
import Rightside from './Rightside';
import LatestNews from "./LatestNews";
import Rolling from './Rolling';
import "./rolling.css";
import Video from "./Video";


// const API_BASE = "http://localhost/myapp/api/uploads";

const API_BASE = "https://spst.in/myapp/api/uploads";

function Home() {

	const [uploads, setUploads] = useState([]);
	const [editId, setEditId] = useState(null);
	const [editName, setEditName] = useState('');

	useEffect(() => {
		fetchUploads();
	}, []);

	const fetchUploads = async () => {
		const res = await axios.get(`${API_BASE}/get.php`);
		setUploads(res.data);
	};

	const handleDelete = async (id) => {
		if (!window.confirm("Delete this record?")) return;
		await axios.post(`${API_BASE}/delete.php`, { id });
		fetchUploads();
	};

	const startEdit = (item) => {
		setEditId(item.id);
		setEditName(item.name);
	};

	const saveEdit = async () => {
		await axios.post(`${API_BASE}/update.php`, { id: editId, name: editName });
		setEditId(null);
		fetchUploads();
	};



	return (
		<div>


			{/* <Popup /> */}

			{/* <Slider /> */}
			<Video />
			<Rolling />

			{/* <div className="container" style={{display:'flex',width:'100%',marginBottom:'25px'}}>
			<div className="col-md-2" style={{background:'orange',color:'maroon',display:'flex',alignItems:'center',justifyContent:'center',borderRadius:'0px 0px 15px 15px'}}>
				<h4 style={{fontWeight:'600',color:'maroon'}}>Latest Updates</h4>
			</div>
			<div className="col-md-10" style={{background:'maroon',padding:'5px',borderRadius:'0px 0px 15px 15px',display:'flex',alignItems:'middle'}}>
				<Marquee speed={50} gradient={false} pauseOnHover>
					<div class="news_post_title" style={{padding:'0px'}}><p style={{color:'white',fontSize:'12pt'}}>For enquiries and booking, Contact at +91 471 246 6830</p></div>
				</Marquee>
			</div>
	  </div> */}
			<div class="booking-container">

				{/* <!-- SINGLE DAY --> */}
				<div class="booking-box single">
					<div class="icon">
						<img src="https://cdn-icons-png.flaticon.com/512/2972/2972357.png" alt="Single Day Pooja Booking" />
					</div>
					<h3 className="books-3-ways">Single Day Pooja Booking</h3>
					<p>Book pooja for a specific auspicious day with full temple rituals.</p>
					<div class="infobar">
						<span></span>
					</div>
					<div class="book-btn">
						<a href="https://booking.peralasserytemple.in/Default.aspx">
							Book Now <span>➜</span>
						</a>
					</div>

				</div>

				{/* <!-- MULTIPLE DAY --> */}
				<div class="booking-box multiple">
					<div class="icon">
						<img src="https://cdn-icons-png.flaticon.com/512/3652/3652191.png" alt="Multi dy Pooja Booking" />
					</div>
					<h3 className="books-3-ways">Multiple Day Pooja</h3>
					<p>Schedule pooja services for several days or festivals.</p>
					<div class="infobar">
						<span></span>
					</div>
					<div class="book-btn">
						<a href="https://booking.peralasserytemple.in/multiple.aspx">
							Book Now <span>➜</span>
						</a>
					</div>

				</div>

				{/* <!-- E-KANIKKA --> */}
				{/* <div class="booking-box ekanikka">
					<div class="icon">
						<img src="https://cdn-icons-png.flaticon.com/512/2331/2331944.png" alt="e-kanikka" />
					</div>
					<h3 className="books-3-ways">E-Kanikka</h3>
					<p>Offer digital donations securely to the deity from anywhere.</p>
					<div class="infobar">
						<span></span>
					</div>
					<div class="book-btn">
						<a href="#">
							Donate Now <span>➜</span>
						</a>
					</div>

				</div> */}

			</div>

			{/* <div className="row">
				<LatestNews />
			</div> */}

			<div className="row">

				<div className="col-12 col-md-8" style={{ marginBottom: '50px' }}>

					{/* <p className="about" >
						ത്രേതായുഗത്തിൽ വനവാസകാലത്ത് യാത്രാമദ്ധ്യേ ശ്രീ അയ്യപ്പ ക്ഷേത്രത്തിൽ ആഗതനായ ഭഗവാൻ ശ്രീരാമചന്ദ്രൻ ഇവിടെ സുബ്രഹ്മണ്യ സാന്നിദ്ധ്വം അനുഭവപ്പെട്ടതിനാൽ സുബ്രഹ്മണ്യ പ്രതിഷ്ഠ നടത്തുന്നതിനായി സന്തത സഹചാരിയായ ശ്രീ ഹനുമാൻ സ്വാമിയോടു സുബ്രഹ്മണവിഗ്രഹം കൊണ്ടുവരുവാൻ നിർദ്ദേശിക്കുകയും മുഹൂർത്ത സമയത്ത് വിഗ്രഹം എത്താതിരുന്നതിനാൽ മുഹൂർത്തം തെറ്റാതിരിക്കാൻ ശ്രീരാമൻ തന്റെ കൈയ്യിലെ പെരുവളയൂരിയെടുത്തു പ്രതിഷ്ഠിക്കുകയും പെരുവള പ്രതി ഷ്ഠിക്കപ്പെട്ട ക്ഷേത്രവും, പ്രദേശവും പെരുവളശ്ശേരി എന്നും, കാലാന്തരത്തിൽ പെരളശ്ശേരിയായി പ്രസിദ്ധി നേടുകയും ചെയ്തു.
പൗരാണികവും കേരളവാസ്തു ശിൽപ്പചാരുത വിളിച്ചോതുന്നതുമായ മനോഹരമായ തീർത്ഥക്കുളം ഭക്തജനങ്ങളെ ഹഠാദാകർഷിക്കുകയും ആയത് ക്ഷേത്രത്തിന്റെ മാത്രം പ്രത്യേകതയായി നിലനിൽക്കുകയും ചെയ്തു വരുന്നു. കേരളത്തിലെ നാഗാരാധന നടക്കുന്ന പ്രധാന ക്ഷേത്രങ്ങളിലൊന്നാണ് ശ്രീ പെരളശ്ശേരി ക്ഷേത്രം.
					</p> */}
					<div className="">
						<div className="row">
							<div className="col-md-12">
								<div className="frame">
									<div className="row frame-1-" style={{ paddingTop: '100px', paddingBottom: '100px' }}>
										<div className="col-md-3">
											<div className="leftimage">
												<img src="./images/murugan-2.png" />
											</div>
										</div>
										<div className="col-md-9">
											<div className="frontbox">
												<p className="historyheadeg"> ശ്രീ പെരളശ്ശേരി ക്ഷേത്രം</p>
												<p className="frame-1-p">
													ഉത്തര കേരളത്തിലെ അതി പുരാതനവും പ്രശസ്തവുമായ  ശ്രീ പെരളശ്ശേരി സുബ്രഹ്മണ്യസ്വാമീ ക്ഷേത്രം  കണ്ണൂർ നഗരത്തിൽ നിന്നും  കൂത്തുപറമ്പ റൂട്ടിൽ 14 കിലോമീറ്ററും തലശ്ശേരി മമ്പറം വഴി 14 കിലോമീറ്ററും അകലെയായി  സ്ഥിതി ചെയ്യുന്നു. പ്രകൃതി ഭംഗി പരിലസിക്കുന്ന പെരളശ്ശേരി ഗ്രാമത്തിന്റെ തിലകമാണ് ഈ മഹാക്ഷേത്രം. വാസ്തുശിൽപ്പ ഭംഗി വിളിച്ചോതുന്ന ക്ഷേത്രക്കുളം അതി മനോഹരമാണ്. സഹസ്രാബ്ദങ്ങളുടെ പഴക്കമാണ് ഈ ക്ഷേത്രത്തിനുള്ളത് എന്നാണ് വിശ്വാസം.
												</p>

												{/* <Link to="/Ithihyam" className="btn btn-warning pos">Read More</Link> */}
											</div>
										</div>
									</div>
								</div>
							</div>
							{/* <div className="col-md-12">
								<div className="frame">
									<div className="row frame-1">
										<div className="col-md-3">
											<div className="leftimage">
												<img src="./images/ram.png" />
											</div>
										</div>
										<div className="col-md-9">
											<div>
												<p className="historyheadeg">ശ്രീ മക്രേരി ക്ഷേത്രവും ജീർണ്ണോദ്ധാരണ പ്രവർത്തനങ്ങളും</p>
												<p className="frame-1-p">
													ആർഷ ഭാരത സംസ്‌കാരത്തിൻ്റെ ഭാഗമായി ലോകനന്മയെ മുൻനിർത്തി ക്കൊണ്ടും ജനങ്ങളുടെ ഭാവിശ്രേയസ്സിന്നുതകുമാറും ഋഷീശ്വരന്മാരും അവതാര പുരുഷന്മാരും ദേവതാരാധനയ്ക്കനുയോജ്യമായ നിരവധി ദേവാലയങ്ങൾ ഭാരത ത്തിലെങ്ങും സ്ഥാപിച്ചിട്ടുണ്ട്.
												</p>
												<Link to="/Activities" className="btn btn-warning pos">Read More</Link>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-12">
								<div className="frame">
									<div className="row frame-1">
										<div className="col-md-3">
											<div className="leftimage">
												<img src="./images/ram.png" />
											</div>
										</div>
										<div className="col-md-9">
											<div>
												<p className="historyheadeg">സുബ്രഹ്മണ്യ സങ്കല്പ്‌പം</p>
												<p className="frame-1-p">
													സ്ക‌ന്ദപുരാണത്തിൽ സുബ്രഹ്മണ്യ ഉൽപ്പത്തിയെപ്പറ്റി പ്രതിപാദിക്കുന്നുണ്ട്. താരകാസുരവധത്തിനായി ദേവസേനാനിയായി സുബ്രഹ്മണ്യൻ ശിവപുത്രനായി പിറന്നു.
												</p>
												<Link to="/Imagination" className="btn btn-warning pos">Read More</Link>
											</div>
										</div>
									</div>
								</div>
							</div>  */}
						</div>
					</div>
					<div class="notice-container" style={{marginBottom:'100px',background:'white',boxShadow:'0px 0px 40px silver inset',border:'none',backgroundImage:'url(./images/slider-1.jpg)', padding: '25px', backgroundSize: 'cover', backgroundPosition: 'left', backgroundAttachment: 'fixed' }}>

						<div class="notice-title" style={{background:'white',padding:'10px'}}>
						<h2>പ്രധാന വഴിപാടുകൾ</h2>
						</div>

						<div class="notice-grid">

							{/* <!-- Card 1 --> */}
							<div class="notice-card-1">
								<h3>സർപ്പബലി സപരിവാര പൂജ</h3>
								
							</div>

							{/* <!-- Card 2 --> */}
							<div class="notice-card-1">
								<h3>കോഴിമുട്ട</h3>
								
							</div>

							{/* <!-- Card 3 --> */}
							<div class="notice-card-1">
								<h3>സുബ്രഹ്മണ്യ പൂജ</h3>
								
							</div>
							<div class="notice-card-1">
								<h3>നിറമാല</h3>
								
							</div>
							<div class="notice-card-1">
								<h3>ഉദയാസ്തമന പൂജ</h3>
								
							</div>
							<div class="notice-card-1">
								<h3>സർപ്പബലി</h3>
								
							</div>


						</div>

					</div>

					<div class="notice-container">

						<div class="notice-title">
							നാഗാരാധനയ്ക്ക്‌ പ്രസിദ്ധപ്പെട്ട ക്ഷേത്രം
						</div>

						<div class="notice-grid">

							{/* <!-- Card 1 --> */}
							<div class="notice-card">
								<h3>വാർഷിക മഹോത്സവം</h3>
								<ul>
									<li>ധനു 4ന്‌ രാത്രി കൊടിയേറ്റം</li>
									<li>ധനു 11ന്‌ രാവിലെ ആറാട്ട്</li>
								</ul>
							</div>

							{/* <!-- Card 2 --> */}
							<div class="notice-card">
								<h3>വിശേഷ ദിവസങ്ങള്‍</h3>
								<ul>
									<li>തുലാം സംക്രമം (കാവേരി സംക്രമം), തുലാം 10.11</li>
									<li>വൃശ്ചികം ഷഷ്ഠി ഉത്സവം</li>
									<li>അയ്യപ്പസ്വാമി പ്രതിഷ്ഠാദിനം കുംഭം 11</li>
								</ul>
							</div>

							{/* <!-- Card 3 --> */}
							<div class="notice-card">
								<h3>മാസവിശേഷങ്ങൾ</h3>
								<ul>
									<li>ആയില്ല്യം, വെളുത്തപക്ഷത്തിലെ ഷഷ്ഠി, ഉത്രം</li>
								</ul>
							</div>

						</div>

					</div>
					<div className="container" style={{ padding: '20px', background: 'white' }}>
						<h3 style={{ textAlign: 'center',fontFamily:'anek malayalam' }}>ക്ഷേത്ര നവീകരണം, അന്നദാനം എന്നിവയിലേക്ക് സംഭാവനകൾ സ്വീകരിക്കുന്നതാണ്</h3>
						<hr />
						<h4 style={{ textAlign: 'center' }}>“DONATIONS ARE BEING ACCEPTED FOR TEMPLE RENOVATION AND ANNADANAM"</h4>
					</div>


				</div>
				<div className="col-12 col-md-4" style={{ backgroundImage: 'url(./images/slider-1.jpg)', padding: '25px', backgroundSize: 'cover', backgroundPosition: 'left', backgroundAttachment: 'fixed' }}>
					<div style={{ border: '1px solid silver', borderRadius: '10px', boxShadow: '0px 0px 10px silver inset', padding: '25px', paddingBottom: '20px', background: 'white' }}>
						<Rightside />

					</div>
					<div class="container card" style={{ paddingBottom: '180px', paddingTop: '150px' }}>
						<div class="icon">🛕</div>

						<div class="title" style={{fontFamily:'anek malayalam'}}>പാരമ്പര്യ ഊരാളൻമാർ :</div>

						<ol class="list">
							<li>കെ.ഇ.സതീശൻ</li>
							<li>കെ.ഇ.കുഞ്ഞികൃഷ്ണൻ തങ്ങൾ</li>
							<li>കെ.അപ്പുക്കുട്ട പൊതുവാൾ</li>
						</ol>

						<div className="manager">
							മാനേജർ: ഇ.നാരായണൻ
						</div>
					</div>

				</div>
			</div>
		</div>

	);
}

export default Home;